import React, { PureComponent } from 'react';

import './NavigationMenu.style';
import Link from 'Component/Link';
import companyCred from "Src/Value/companyCred.json";

export class NavigationDesktopMenu extends PureComponent {
    static propTypes = {
        MenuLinksData: this.propTypes,
        closemenu: this.propTypes
    };

    state = {
        selectedItem: ""
    }

    closemenu = () => {
        const { closemenu } = this.props;

        this.setState({
            selectedItem: ""
        });

        closemenu();
    }

    setItem = (title) => {
        this.setState({
            selectedItem: title
        });
    }

    renderMenuItems = () => {
        const { selectedItem } = this.state;
        const { MenuLinksData } = this.props;

        return (
            <div className='NavigationMenu-MenuItemsWrapper'>
                {
                    MenuLinksData?.map((value, index) => (
                        !value?.categories?.length ?
                            <div style={{ "--index": index }} className='NavigationMenu-ItemsWrapper' key={index}>
                                <Link to={value?.link} onClick={() => { this.closemenu() }}>
                                    <h4>{value?.label}</h4>
                                </Link>
                            </div>
                            : <div style={{ "--index": index }} className={'NavigationMenu-ItemsWrapper' + (value?.label === selectedItem ? " NavigationMenu-ItemsWrapper_Selected" : "")} key={index} onClick={() => this.setItem(value?.label)}>
                                <h4>{value?.label?.toLowerCase()}</h4>

                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.25 6.5L14.75 12L9.25 17.5" stroke="#969696" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>

                                <div className={'NavigationMenu-SubMenuItemsWrapper' + (value?.label === selectedItem ? " NavigationMenu-SubMenuItemsWrapper_Selected" : "")}>
                                    <div className='NavigationMenu-SubItemsWrapper'>
                                        {
                                            value?.promotion_banner &&
                                            <Link to={value?.link} onClick={() => { this.closemenu() }}>
                                                <div className='NavigationMenu-PromotionBannerLinks'>
                                                    <img src={value?.promotion_banner} />
                                                    <h3>{value?.label}</h3>
                                                </div>
                                            </Link>
                                        }

                                        {
                                            value?.categories?.map((category, i) => (
                                                <div className='NavigationMenu-SubItem' style={{ "--i": i }} key={i}>
                                                    <h3>{category?.title?.toLowerCase()}</h3>

                                                    <div className={'NavigationMenu-SubItemCategory' + (category?.isShape ? " NavigationMenu-SubItemCategory_isShape" : "") + (category?.isIcon ? " NavigationMenu-SubItemCategory_isIcon" : "")}>
                                                        {
                                                            category?.subcategories?.map((subcategory, ins) => (
                                                                <Link
                                                                    key={ins}
                                                                    className='CustomMenu-Subcategories-Link'
                                                                    to={subcategory?.link}
                                                                    onClick={() => this.closemenu()}
                                                                >
                                                                    {subcategory?.image && <img src={subcategory?.image} />}
                                                                    {subcategory?.icon && subcategory?.icon}
                                                                    {/* {subcategory?.icon && <div dangerouslySetInnerHTML={{ __html: subcategory?.icon }}></div>} */}
                                                                    <h5 style={{ "--ins": ins }}>{subcategory?.item?.toLowerCase()}</h5>
                                                                </Link>
                                                            ))
                                                        }
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>

                                    <div className='NavigationMenu-SubItemImageWrapper_OuterWrapper'>
                                        <div className='NavigationMenu-SubItemImageWrapper'>
                                            {
                                                value?.categories2?.map((category, i) => (
                                                    <div className='NavigationMenu-SubItem2' style={{ "--i": i }} key={i}>
                                                        {(category?.title && category?.isShown) && <h3>{category?.title}</h3>}

                                                        <div className={'NavigationMenu-SubItemCategory2' + (category?.mergeColumn ? " NavigationMenu-SubItemCategory2_isMerge" : "")}>
                                                            {
                                                                category?.subcategories?.map((subcategory, ins) => (
                                                                    subcategory?.links?.length ? <div key={ins} className='CustmizeMenu-LinsContainer'>
                                                                        <img src={subcategory?.image} />
                                                                        <div className='CustmizeMenu-Links'>
                                                                            {
                                                                                subcategory?.links?.map((value, index) => (
                                                                                    <Link
                                                                                        key={index}
                                                                                        className='CustomMenu-Subcategories2-Link'
                                                                                        to={value?.link}
                                                                                        onClick={() => this.closemenu()}
                                                                                    >
                                                                                        <h5 style={{ "--ins": ins }}>{value?.item}</h5>
                                                                                    </Link>
                                                                                ))
                                                                            }
                                                                        </div>
                                                                    </div> :
                                                                        <Link
                                                                            key={ins}
                                                                            className='CustomMenu-Subcategories2-Link'
                                                                            to={subcategory?.link}
                                                                            onClick={() => this.closemenu()}
                                                                        >
                                                                            <img src={subcategory?.image} />
                                                                            <h5 style={{ "--ins": ins }}>{subcategory?.item}</h5>
                                                                        </Link>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                    ))
                }
            </div>
        )
    }

    bookAppointMentClick = () => {
        const bookappoinetmentmodel = document.getElementById("appointment-popup");
        if (bookappoinetmentmodel) {
            bookappoinetmentmodel.style.display = "flex";

            const bookappoinetmentmodelcloseicon = document.getElementsByClassName("appointment_closeIcon");
            if (bookappoinetmentmodelcloseicon?.length > 0) {
                bookappoinetmentmodelcloseicon[0].onclick = function () {
                    bookappoinetmentmodel.style.display = "none";
                }
            }
        }
    }

    render() {
        return (
            <>
                <div className='NewHeader-CloseMenu' onClick={() => this.closemenu()}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.63574 18.3643L18.3637 5.63634" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M5.63574 5.63574L18.3637 18.3637" stroke="#1E1E1E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span>Close</span>
                </div>

                {this.renderMenuItems()}

                <div className='NewHeader-BottomLinksWrapper'>
                    <div className='NewHeader-BottomLinks'>
                        <Link to={"/customer/account"} onClick={() => this.closemenu()}>
                            <span>My Account</span>
                        </Link>

                        <button id="appointment" className="" onClick={() => this.bookAppointMentClick()}>Book an Appointment</button>

                        <Link to={"/contact"} onClick={() => this.closemenu()}>
                            <span>Contact Us</span>
                        </Link>

                        <a href={`tel:${companyCred?.mobileNumber}`}>
                            <span>Call US : <span>{companyCred?.mobileNumber}</span></span>
                        </a>
                    </div>
                </div>
            </>
        );
    }
}

export default NavigationDesktopMenu;
